import { render, staticRenderFns } from "./common-problem-chinese.vue?vue&type=template&id=50df03c6&scoped=true"
import script from "./common-problem-chinese.vue?vue&type=script&lang=js"
export * from "./common-problem-chinese.vue?vue&type=script&lang=js"
import style0 from "./common-problem-chinese.vue?vue&type=style&index=0&id=50df03c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50df03c6",
  null
  
)

export default component.exports